const LOGOS = [
  "Atelier Mavi",
  "Klinik Doruk",
  "Lezzet Durağı",
  "Beyaz Butik",
  "Otomotiv Park",
  "Estetica",
  "Vega Cafe",
  "Premium Spa",
];

export default function ClientsMarquee() {
  const items = [...LOGOS, ...LOGOS];
  return (
    <section
      data-testid="clients-marquee"
      className="relative py-12 bg-white border-y border-slate-200/70 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-5">
        <div className="text-center text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">
          Birlikte çalıştığımız markalar
        </div>
      </div>
      <div className="relative">
        <div
          className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-white to-transparent z-10"
          aria-hidden
        />
        <div
          className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-white to-transparent z-10"
          aria-hidden
        />
        <div className="flex ab-marquee-track w-max">
          {items.map((label, i) => (
            <div
              key={i}
              className="flex items-center gap-2 px-8 py-3 mx-1 text-[var(--ab-navy)]/60 font-display font-bold text-xl tracking-tight whitespace-nowrap"
            >
              <span
                className="w-7 h-7 rounded-lg flex items-center justify-center text-[10px] font-bold text-white"
                style={{
                  background:
                    "linear-gradient(135deg, #2D3FFF 0%, #5A3FFF 100%)",
                }}
              >
                {label
                  .split(" ")
                  .map((w) => w[0])
                  .slice(0, 2)
                  .join("")}
              </span>
              {label}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
